//Width 420px was the width taken for mobile view
//Width 1180px-420px was the width taken for Tablet view
//Width above 1180px was the width taken for Desktop

export const ROUTES = {
  HOME: "/", //done
  LOGIN: "/login", //doing
  REGISTER: "/register", //done
  VERIFYOTP: "/verify-otp", //done
  RESETPASSWORD: "/reset-password", //done
  CHANGEPASSWORD: "/change-password", //done
  PRODUCTSINGLE: "/product-single", //done //endless sponsorship//go fund me
  SEARCH: "/search", //done add country filter on the left hand side
  CART: "/cart", //done
  CHECKOUT: "/checkout", //done **
  CATEGORY: "/category",
  RECEIPT: "/receipt", //done
  ACCOUNT: "/account", //done
  ORDER: "/account/order", //doing
  INBOX: "/account/inbox", //done
  PENDINGREVIEW: "/account/review/pending", //done
  SAVEDITEM: "/account/saved-item", //done
  BUYER_DASHBOARD: "/buyer/dashboard", //done
  PRODUCTDETAIL: "/sponsorship/product/detail",
  MESSAGE: "/message", //done
  BUYER_ORDER: "/buyer/order", //done


  SPONSORSHIP: "/sponsorship",
  ADD_SPONSORSHIP_PRODUCT: "/sponsorship/add-info",
  ADD_SPONSORSHIP_PRODUCT_2: "/sponsorship/product-info",
  ADD_SPONSORSHIP_PRODUCT_3: "/sponsorship/product-attributes",


  WAITINGLIST: "/waiting-list",
  ADDPAYMENT: "/account/add-payment", //done **
  BUYER_CATALOG: "/buyer/catalog", //done
  CAREERS: "/careers", //done
  CAREERS_DETAIL: "/careers/job",
  CAREERS_FORM: "/careers/apply", //done
  ORDERTRACK: "/account/order/track", //done
  RATEPRODUCT: "/account/order/rate",
  ABOUT_US: "/about-us", //done
  BUYER_TRANSACTION: "/buyer/transaction", //done
  MESSAGE_SINGLE: "/message-single", //done
  RECENTLYVIEWED: "/account/recently-viewed", //done
  SELLER_DASHBOARD: "/seller/dashboard", //done
  SELLER_MESSAGE_SINGLE: "/seller/message/single", //done
  SELLER_MESSAGE: "/seller/message", //done
  SELLER_ORDER: "/seller/order", // same as  /buyer/order
  SELLER_ORDER_2: "/seller/order/2", //done
  // SELLER_ORDER_3: "/seller/order/3", //done
  SELLER_REGISTRATION: "/seller/registration", //done //
  SELLER_REGISTRATION_2: "/seller/registration/2", //done
  SELLER_REGISTRATION_3: "/seller/registration/3", //done
  LISTING: "/seller/listing", //done
  LISTING_DETAIL: "/seller/listing/details", //done  //need refixing
  NDAMESSAGES: "/seller/NDA/messages", //done
  NDAPOPUP: "/seller/NDA/select",
  MARKETINGSUMMARY: "/seller/marketing/summary", //done
  MARKETING: "/seller/marketing", //done
  MARKETINGCAMPAIGN: "/seller/marketing/camapaign", //done
  MARKETINGINVENTORY: "/seller/marketing/inventory", //done
  MARKETINGIPRICERANGE: "/seller/marketing/price-range",
  SELLER_PAYMENTS: "/seller/payments",
  SELLER_PAYOUTS: "/seller/payouts",
  ADMIN_DASHBOARD: "/admin-panel/dashboard",
  ADMIN_CAMPAIGNS: "/admin-panel/campaigns",
  ADMIN_SETTINGS: "/admin-panel/settings",
  ADMIN_TARIFFS: "/admin-panel/tariffs",
  ADMIN_USERS: "/admin-panel/users",
  ADMIN_DISPUTES: "/admin-panel/disputes",
  ADMIN_REPORTS: "/admin-panel/reports",
  ADMIN_MODERATION: "/admin-panel/moderation",
  ADMIN_ECO_APPROVALS: "/admin-panel/eco-approvals",
  ADMIN_ANNOUNCEMENTS: "/admin-panel/announcements",
  ADMIN_SUPPORT: "/admin-panel/support",
  PERFORMANCE: "/seller/performance",
  NDA_PROPOSALS: "/seller/NDA/proposals",
  MANUFACTURING: "/manufacturing",
  ECO_FRIENDLY: "/eco-friendly",
  COMPANY_PROFILE: "/company",
  SELLER_VERIFICATION: "/seller/verification",
  SELLER_BOOST: "/seller/boost",
  BUYER_QUOTES: "/buyer/quotes",
  SELLER_QUOTES: "/seller/quotes",
  COMPARE: "/compare",
  SHARED_WISHLIST: "/wishlist",
  SELLER_BUNDLES: "/seller/bundles",
  SELLER_COLLECTIONS: "/seller/collections",
  SELLER_STORE_SETTINGS: "/seller/store-settings",
  BUYER_SAVED_SEARCHES: "/buyer/saved-searches",
  BUYER_PRICE_ALERTS: "/buyer/price-alerts",
  BUYER_WAITLIST: "/buyer/waitlist",
  BUYER_FOLLOWING: "/buyer/following",
  SELLER_BULK_UPLOAD: "/seller/bulk-upload",
  SELLER_BULK_PRICE_UPDATE: "/seller/bulk-price-update",
  SELLER_BULK_INVENTORY_UPDATE: "/seller/bulk-inventory-update",
  SELLER_DISPUTES: "/seller/disputes",
  BUYER_DISPUTES: "/buyer/disputes",
  BUYER_DISPUTE_DETAIL: "/buyer/disputes/:id",
  SELLER_DISPUTE_DETAIL: "/seller/disputes/:id",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  CONTACT: "/contact",
  CHANGELOG: "/changelog",
  STATS: "/stats",
  ADMIN_SHIPPING_RATES: "/admin-panel/shipping-rates",
  BUYER_RETURNS: "/buyer/returns",
  SELLER_RETURNS: "/seller/returns",
  SELLER_PRODUCT_ANALYTICS: "/seller/products/:slug/analytics",
  BUYER_SUBSCRIPTIONS: "/buyer/subscriptions",
  ADMIN_TAX_ACCOUNTING: "/admin-panel/tax-accounting",
  ADMIN_TAX_REPORTS: "/admin-panel/tax-reports",
  SELLER_ADS: "/seller/ads",
  ADMIN_ADS: "/admin-panel/ads",
  SUCCESS_STORIES: "/success-stories",
  BACKED_CAMPAIGNS: "/buyer/backed-campaigns",
  CAMPAIGN_BACKERS: "/seller/campaign-backers",
  SIGNING_HISTORY: "/seller/signing-history",
  GUEST_SHIPPING_SURVEY: "/sponsorship/shipping-survey",
  PRIVACY_CENTER: "/account/privacy",
  RFQ_BOARD: "/seller/rfq-board",
  RFQ_ANALYTICS: "/seller/rfq-analytics",
  ADMIN_RFQ: "/admin-panel/rfq",
  ADMIN_QA_CHECKLIST: "/admin-panel/qa-checklist",
  BUYER_RFQS: "/buyer/rfqs",
  CREATE_RFQ: "/buyer/rfqs/create",
  MANUFACTURER_RFQS: "/seller/rfqs",
  SELLER_ANALYTICS: "/seller/analytics",
  SELLER_REPORTS: "/seller/reports",
  SELLER_EARNINGS: "/seller/earnings",
  NOTIFICATION_CENTER: "/account/notifications",
  NOTIFICATION_PREFERENCES: "/account/notifications/preferences",
  BUYER_PROTECTION: "/buyer-protection",
  BUYER_SAMPLES: "/buyer/samples",
  SELLER_SAMPLES: "/seller/samples",
  ADMIN_PLATFORM_HEALTH: "/admin-panel/platform-health",
  REFERRAL_DASHBOARD: "/account/referrals",
  ADMIN_BLOCKED_KEYWORDS: "/admin-panel/blocked-keywords",
  SELLER_MODERATION: "/seller/moderation",
  GIFT_CARDS: "/gift-cards",
  CREDIT_WALLET: "/buyer/credit-wallet",
  ADMIN_GIFT_CARDS: "/admin-panel/gift-cards",
  ADMIN_SEARCH_ANALYTICS: "/admin-panel/search-analytics",
  ADMIN_CERTIFICATIONS: "/admin-panel/certifications",
  SELLER_CERTIFICATIONS: "/seller/certifications",
  SHARED_WISHLIST_FOLDER: "/wishlist/folder",
  SELLER_WISHLIST_ANALYTICS: "/seller/wishlist-analytics",
  SELLER_SUBSCRIPTION: "/seller/subscription",
  ADMIN_SELLER_APPLICATIONS: "/admin-panel/seller-applications",
  BUYER_LOYALTY: "/buyer/loyalty",
};
